import HealthCareDisparityInfo from './HealthCareDisparityInfo';

export default HealthCareDisparityInfo;
